export default "__VITE_ASSET__Eqw1clAG__"